import { Deserializable } from '../_common/deserializable';

export class StreamHistory implements Deserializable{
    id: string;
    msgId: string;
    shortCode: string;
    keyword: string;
    operator: string;
    requestUri: string;
    queryString: string;
    uriVariables: string;
    transactionAt: number;
    transactionAtView: string;
    createdAt: number;
    createdAtView: string;
    panOutState: number;
    panOutStateView: string;
    panOutAt: number;
    panOutAtView: string;
    panOutMsg: string;
    panOutUrl: string;
    panOutBody: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
